module.exports = __webpack_public_path__ + "img/icon-arrow-right-white.854c3617.svg";